import React from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { Box, Card, CardContent, Stack, Checkbox, Typography, TextField, Button, IconButton } from '@mui/material';
import { updateNotificationSettingsAction } from '../../../services/request';
import RichTextEditor from './RichTextEditor';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';
import { EmailEditorImpl } from './EmailEditorImpl';

const validationSchema = Yup.object({
  send_email: Yup.boolean(),
  send_sms: Yup.boolean(),
  email_subject: Yup.string(),
  email_message: Yup.string(),
  sms_message: Yup.string()
});

const NotificationSettings = ({ id, send_email, send_sms, email_subject, email_message, sms_message,
  setNotificationSettings, show_in_email_editor, email_editor_design_object }) => {
  const { mutate } = useMutation(updateNotificationSettingsAction);
  const [showRichText, setShowRichText] = React.useState(false);

  const handleToggle = () => setShowRichText(prev => !prev);

  const handleSubmit = async (orderId, values) => {
    const { error, payload } = await mutate(orderId, values);
    if (!error) {
      console.log(payload);
      setNotificationSettings(prev => prev.map(element => element.id === payload.id ? payload : element));
      formik.resetForm({
        values
      });
    } else {
      toast.error('Nie udało się zapisać zmian');
    }
  };

  const formik = useFormik({
    initialValues: {
      send_email,
      send_sms,
      email_subject: _.isNil(email_subject) ? '' : email_subject,
      email_message: _.isNil(email_message) ? '' : email_message,
      sms_message: _.isNil(sms_message) ? '' : sms_message,
      email_editor_design_object: _.isNil(email_editor_design_object) ? null : email_editor_design_object
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      console.log(values);
      handleSubmit(id, values);
    }
  });

  return (
    <Card sx={{ mt: 4 }}>
      <CardContent>
        <form onSubmit={formik.handleSubmit}>
          <Stack direction="column" justifyContent="space-between" spacing={4}>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
              <Checkbox name="send_email" checked={formik.values.send_email} onChange={formik.handleChange}/>
              <Typography variant="subtitle2">Powiadomienia E-mail</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
              <Checkbox name="send_sms" checked={formik.values.send_sms} onChange={formik.handleChange}/>
              <Typography variant="subtitle2">Powiadomienia SMS</Typography>
            </Stack>
            <TextField
              fullWidth
              label="Temat E-maila"
              name="email_subject"
              value={formik.values.email_subject}
              onChange={formik.handleChange}
            ></TextField>
            {!show_in_email_editor && <IconButton
              onClick={handleToggle}
              color={showRichText ? 'primary' : 'default'}
              sx={{ alignSelf: 'flex-end' }}
            >
              <EditIcon />
            </IconButton>}
            {show_in_email_editor ? <EmailEditorImpl formik={formik}/> : showRichText
              ? <RichTextEditor text={formik.values.email_message} formik={formik} />
              : <TextField
                multiline
                rows={10}
                fullWidth
                label="Wiadomość E-mail"
                name="email_message"
                value={formik.values.email_message}
                onChange={formik.handleChange}
              ></TextField>
            }
            <TextField
              multiline
              rows={5}
              fullWidth
              label="Wiadomość SMS"
              name="sms_message"
              value={formik.values.sms_message}
              onChange={formik.handleChange}
            ></TextField>
          </Stack>
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Button variant="contained" type="submit" disabled={!formik.dirty}>Zapisz zmiany</Button>
          </Box>
        </form>
      </CardContent>
    </Card>
  );
};


export default NotificationSettings;
